(function () {
  var countdown = document.getElementById('bb-countdown-wrap');
  if (!countdown) return;

  // --- Countdown timer ---
  var minutes = parseInt(countdown.getAttribute('data-countdown-end'), 10) || 476;
  var endTime = Date.now() + minutes * 60 * 1000;

  var daysEl = countdown.querySelector('[data-days]');
  var hoursEl = countdown.querySelector('[data-hours]');
  var minsEl = countdown.querySelector('[data-minutes]');
  var secsEl = countdown.querySelector('[data-seconds]');

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var remaining = Math.max(0, endTime - Date.now());
    var d = Math.floor(remaining / (1000 * 60 * 60 * 24));
    var h = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    var m = Math.floor((remaining / (1000 * 60)) % 60);
    var s = Math.floor((remaining / 1000) % 60);

    if (daysEl) daysEl.textContent = pad(d);
    if (hoursEl) hoursEl.textContent = pad(h);
    if (minsEl) minsEl.textContent = pad(m);
    if (secsEl) secsEl.textContent = pad(s);

    if (remaining <= 0) clearInterval(intervalId);
  }

  tick();
  var intervalId = setInterval(tick, 1000);
})();